import styles from '../student.admin.module.scss'

import { IRegistration, ViewType } from '../student.admin'

export interface IProps {
  registrations: IRegistration[]
  setRegistration: React.Dispatch<React.SetStateAction<IRegistration>>
  setView: React.Dispatch<React.SetStateAction<ViewType>>
}

export const Registration = ({
  registrations,
  setRegistration,
  setView,
}: IProps) => {
  return (
    <>
      <p>Inscrições</p>
      <div className={styles.registrations}>
        {registrations.map((item) => {
          return (
            <div
              onClick={() => {
                setRegistration(item)
                setView('VER REGISTRATIONS')
              }}
              className={styles.inscricao}
            >
              <p>{item?.institution ?? 'NAO TEM INSTITUIÇÃO'}</p>
              <p>{item?.course ?? 'NAO TEM CURSO'}</p>
              <p>{item?.category ?? 'NAO TEM CATEGORIA'}</p>
              <p>{`Turno: ${item?.shift}`}</p>
            </div>
          )
        })}
      </div>
    </>
  )
}
